import BadgeIcon from './BadgeIcon';

export default BadgeIcon;
